import { ReactNode } from "react";
import { TabContent, TabLabel, TabLabelWrapper, TabsWrapper } from "./atoms";

export function Tabs({
  type = "line",
  activeKey,
  items = [],
  headerExtraRender,
  labelGap,
  onChange,
  className,
  notReRender = false,
  maxHeight = "100%",
}: TabsProps) {
  const handleChange = (event: MouseEvent<HTMLElement>) => {
    // 从点击的元素开始向上查找包含value属性的元素
    let target = event.target as HTMLElement;
    while (target && target !== event.currentTarget) {
      const valueAttr = target.getAttribute("value");
      if (valueAttr) {
        const optionKeyList = items.map((i) => i.key);
        if (onChange && optionKeyList.includes(valueAttr)) {
          onChange(valueAttr);
        }
        return;
      }
      target = target.parentElement as HTMLElement;
    }
  };
  return (
    <TabsWrapper maxHeight={maxHeight}>
      <TabLabelWrapper type={type} onClick={handleChange} className={className}>
        {items
          .filter((i) => !i.hidden)
          .map((tab) => (
            <TabLabel
              key={tab.key}
              type={type}
              value={tab.key}
              active={activeKey === tab.key}
              labelGap={labelGap}
            >
              {tab.label}
            </TabLabel>
          ))}
        {headerExtraRender ? headerExtraRender : null}
      </TabLabelWrapper>
      {notReRender ? (
        <div>
          {items
            .filter((i) => !i.hidden)
            .map((item: any) => (
              <TabContent
                type={type}
                isShow={item.key === activeKey}
                key={item.key}
                className={"task-eva-tabs-content"}
              >
                {item.children}
              </TabContent>
            ))}
        </div>
      ) : (
        <TabContent
          type={type}
          isShow={true}
          className={"task-eva-tabs-content"}
        >
          {items.find((tab) => tab.key === activeKey)?.children}
        </TabContent>
      )}
    </TabsWrapper>
  );
}

export type IType = "card" | "line" | "common";
export type TabsProps = {
  type?: IType;
  activeKey?: string;
  items: TabItemType[];
  headerExtraRender?: ReactNode;
  labelGap?: number;
  onChange?: (activeKey: string) => void;
  className?: string;
  notReRender?: boolean;
  maxHeight?: string;
};

export type TabItemType = {
  key: string;
  label: ReactNode;
  children: ReactNode;
  hidden?: boolean;
};

export type TabLableType = {
  active: boolean;
  type: IType;
  labelGap?: number;
};
export type TabLableWrapperType = {
  type: IType;
};
export type TabContentType = {
  type: IType;
};

export type TabContentRenderType = {
  type: IType;
  isShow: boolean;
};
